var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" } },
    [
      _c("path", {
        attrs: {
          fill: "currentColor",
          "fill-rule": "nonzero",
          d: "M32.84.093c-16.347 0-15.253 16.96-15.253 16.96S.093 17.053.093 32.547c0 15.493 17 15.253 17 15.253l30.254.12V16.987C47.333 16.987 48.96.093 32.84.093zM17.08 39.04s-8.493 1-8.493-6.88 8.493-6.88 8.493-6.88v13.76zM32.587 8.547c7.493 0 6.746 8.253 6.746 8.253H25.587s-.507-8.253 7-8.253zM39.36 39.04H25.573V25.293h13.774V39.04h.013z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }